import { createAction, props } from '@ngrx/store';
import { AnnouncementPreviewData } from '../../../../system-apps/admin-announcement/+definitions';

/**
 * Actions für den Info-Popup-Dialog.
 */
export class InfoPopupDialogActions {
  private static readonly prefix = '[Info Popup Dialog]';

  /**
   * Öffnet den Info-Popup-Dialog im Vorschau-Modus (Admin-Preview).
   */
  public static openPreview = createAction(
    `${this.prefix} Open preview`,
    props<{ previewData: AnnouncementPreviewData }>(),
  );

  /**
   * Öffnet den Info-Popup-Dialog im User-Modus (Endnutzer-Popup).
   * Daten werden aus dem UserAnnouncementEntities-Store gelesen.
   */
  public static openUserPopup = createAction(
    `${this.prefix} Open user popup`,
  );

  /**
   * Wird ausgelöst wenn der X-Button im Dialog geklickt wird.
   * Ermöglicht es, vor dem Schließen zusätzliche Logik auszuführen
   * (z.B. Gelesen-Markierung im User-Modus).
   */
  public static closeViaButton = createAction(
    `${this.prefix} Close via button`,
  );

  /**
   * Schließt den Info-Popup-Dialog.
   */
  public static close = createAction(
    `${this.prefix} Close dialog`,
  );
}
